<template>
    <div class="modal" :style="{display:show?'block':'none'}" style="background: rgba(1,1,1,0.5);">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props:["show"],
        data: function () {
            return {};
        }
    }
</script>